/**
 * Home Page Tutorial
 * Guides users through the home dashboard and its features.
 * Written for older, less tech-savvy users with simple language.
 *
 * Content tone:
 * - All steps are informational (no requiresClick), so use descriptive language
 */

export const homePageTutorial = {
  id: 'home-page',
  name: 'Home Page Tour',
  description: 'Learn about the home dashboard and what each section does',

  steps: [
    {
      id: 'greeting',
      selector: '.home-greeting',
      title: 'Welcome Home',
      content: 'This is your personal dashboard. It gives you a quick overview of your reflection activity.',
      position: 'right',
      highlightPadding: 8,
      disableTargetClick: true
    },
    {
      id: 'todays-prompt',
      selector: '.todays-prompt-card',
      title: 'Today\'s Prompt',
      content: 'Each day, a prompt is suggested to inspire your reflection. You can click "Record" to answer it, or "View Prompts" to browse more.',
      position: 'right',
      waitForElement: true,
      maxWaitTime: 3000,
      highlightPadding: 8,
      disableTargetClick: true
    },
    {
      id: 'stats',
      selector: '.stats-grid',
      title: 'Your Stats',
      content: 'This section tracks your progress: total reflections, how many this week, your current streak, and categories used.',
      position: 'left',
      waitForElement: true,
      maxWaitTime: 3000,
      highlightPadding: 8,
      disableTargetClick: true
    },
    {
      id: 'recent-activity',
      selector: '.bento-card--medium',
      title: 'Recent Activity',
      content: 'Your most recent reflections appear here. You can click any one to view it, or click "View All" to see everything.',
      position: 'right',
      waitForElement: true,
      maxWaitTime: 3000,
      highlightPadding: 8,
      disableTargetClick: true
    },
    {
      id: 'on-this-day',
      selector: '.on-this-day-content',
      title: 'On This Day',
      content: 'This section shows memories from this date in past years. It is a great way to see how you have grown over time.',
      position: 'left',
      waitForElement: true,
      maxWaitTime: 3000,
      highlightPadding: 8,
      disableTargetClick: true
    },
    {
      id: 'categories',
      selector: '.category-breakdown-list',
      title: 'Categories',
      content: 'Here you can see how your reflections are spread across different categories. You can click a category to jump to its prompts.',
      position: 'right',
      waitForElement: true,
      maxWaitTime: 3000,
      highlightPadding: 8,
      optional: true,
      disableTargetClick: true
    },
    {
      id: 'shared-with-me',
      selector: '.shared-with-me-list',
      title: 'Shared With Me',
      content: 'If someone shares their reflections with you, they appear here. The badge shows how many new ones you have not seen yet.',
      position: 'left',
      waitForElement: true,
      maxWaitTime: 3000,
      highlightPadding: 8,
      optional: true,
      disableTargetClick: true
    },
    {
      id: 'help-button',
      selector: '.help-btn',
      title: 'More Tutorials',
      content: 'Tap the "?" button any time to find more tutorials and learn about other features.',
      position: 'bottom',
      highlightPadding: 4
    },
    {
      id: 'complete',
      selector: null,
      title: 'Explore Your Dashboard',
      content: 'That\'s your home page! Come back here any time to check your stats, see today\'s prompt, or revisit old memories.',
      position: 'center',
      isCompletionStep: true
    }
  ]
};
